<template>
  <div>
    <select class="form-control" v-model="valueMutable" v-on:change="changeValue()">
      <option
        :key="'option'+option.value"
        v-for="option in parameter.options"
        :value="option.value"
      >
        {{option.name||option.value}}
      </option>
    </select>
  </div>
</template>

<script>
import InputConfigMixin from '@/febos/global/empresas/componentes/configs/inputs/InputConfigMixin';

export default {
  name: 'ConfigInputSwitchYN',
  mixins: [InputConfigMixin],
  data() {
    return {
      valueMutable: ''
    };
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    config: {
      type: Object,
      required: false,
      default() {
        return {
          option_true: 'Y',
          option_false: 'N',
          label_true: 'Si',
          label_false: 'No'
        };
      }
    },
    parameter: {
      type: Object,
      required: false,
      default() {
        return {
          options: []
        };
      }
    }
  },
  mounted() {
    this.valueMutable = this.value || '';
  },
  methods: {
    changeValue() {
      this.$emit('input', this.valueMutable);
    }
  }
};
</script>
